/** Match the existing design-package SparklineChart's four-pixel plot inset.
 * This only positions the interaction; SparklineChart still draws the curve.
 */
const PLOT_INSET = 4;

export interface HoverPoint {
    x: number;
    y: number;
}

export function apyHoverPoints(
    values: number[],
    timestamps: number[] | undefined,
    width: number,
    height: number
): HoverPoint[] {
    if (width <= 0 || values.length === 0) return [];
    const min = Math.min(...values);
    const range = Math.max(...values) - min;
    const times = timestamps?.length ? timestamps : undefined;
    const start = times?.[0] ?? 0;
    const span = times ? times[times.length - 1] - start : 0;
    return values.map((value, index) => ({
        x:
            PLOT_INSET +
            (width - 2 * PLOT_INSET) *
                (times ? (span === 0 ? 0.5 : (times[index] - start) / span) : index / Math.max(1, values.length - 1)),
        y: PLOT_INSET + (height - 2 * PLOT_INSET) * (range === 0 ? 0.5 : 1 - (value - min) / range)
    }));
}

export function nearestApyPoint(points: HoverPoint[], x: number): number | null {
    if (!points.length) return null;
    return points.reduce(
        (nearest, point, index) => (Math.abs(point.x - x) < Math.abs(points[nearest].x - x) ? index : nearest),
        0
    );
}

export function readoutLeft(x: number, textWidth: number, width: number): number {
    return Math.max(0, Math.min(x - textWidth / 2, width - textWidth));
}
